import React, { useEffect, useState } from "react";
import cx from "classnames";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";

import { Linkedin, Logo, TwitterX } from "@components/Icon";
import { Subtitle, Text } from "@components/Typography";
import Button from "@components/Button";

import styles from "./index.module.scss";

interface FooterProps {
  className?: string;
}

// Basic Section component for full-width content
const Footer: React.FC<FooterProps> = ({ className = "" }) => {
  const [backgroundColor, setBackgroundColor] = useState("#003125");
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/mika-ai-medical-scribe/") {
      setBackgroundColor("#1d2029");
    } else {
      setBackgroundColor("#003125");
    }
  }, [location.pathname]);
  return (
    <div className={cx(styles.Footer, className)} style={{ backgroundColor }}>
      <div className={styles.FooterLeft}>
        <Logo />
        <div className={styles.ConnectSection}>
          <Text className={styles.Address}>
            Suite 201 - 838 11th Avenue SW Calgary, AB T2R 0E5
            <br />
            Calgary Main: 587-327-6334
            <br />
            Toll Free: 877-749-3222
            <br />
            <a href="mailto:info@mikatahealth.com">info@mikatahealth.com</a>
            <br />
          </Text>
          <div className={styles.SocialIcons}>
            <Button
              variant="inline"
              className={styles.Icon}
              onClick={() =>
                window.open("https://www.linkedin.com/company/mikata-health", "_blank")
              }
            >
              <Linkedin />
            </Button>
            <Button
              variant="inline"
              className={styles.Icon}
              onClick={() => window.open("https://x.com/mikatahealth", "_blank")}
            >
              <TwitterX />
            </Button>
          </div>
        </div>
      </div>
      <div className={styles.Navigation}>
        <div className={styles.Group}>
          <Subtitle className={styles.Title}>Product</Subtitle>
          <Link to="/infoway">
            <Text className={styles.NavLink}>Infoway</Text>
          </Link>
          <Link to="/product">
            <Text className={styles.NavLink}>Patient Engagement</Text>
          </Link>
          <Link to="/mika-ai-medical-scribe">
            <Text className={styles.NavLink}>Mika AI Scribe</Text>
          </Link>
          <Link to="/who-we-serve/family-medicine">
            <Text className={styles.NavLink}>For Family</Text>
          </Link>
          <Link to="/who-we-serve/medical-imaging">
            <Text className={styles.NavLink}>For Imaging</Text>
          </Link>
          <Link to="/who-we-serve/specialty-medicine">
            <Text className={styles.NavLink}>For Specialty</Text>
          </Link>
          <Link to="/pricing">
            <Text className={styles.NavLink}>Pricing</Text>
          </Link>
        </div>

        <div className={styles.Group}>
          <Subtitle className={styles.Title}>Company</Subtitle>
          <Link to="/about-us">
            <Text className={styles.NavLink}>About us</Text>
          </Link>
          <Link to="/contact">
            <Text className={styles.NavLink}>Contact us</Text>
          </Link>
          <Link to="/careers">
            <Text className={styles.NavLink}>Careers</Text>
          </Link>
        </div>

        <div className={styles.Group}>
          <Subtitle className={styles.Title}>Terms & Policies</Subtitle>
          <Link to="/terms">
            <Text className={styles.NavLink}>Terms</Text>
          </Link>
          <Link to="/privacy-policy">
            <Text className={styles.NavLink}>Privacy & Security</Text>
          </Link>
          <Link to="/diversity-and-inclusion">
            <Text className={styles.NavLink}>Diversity & Inclusion</Text>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
